module.exports = __webpack_public_path__ + "static/media/client_img_1.47f0fb77.png";